<script lang="ts">
    import clsx from 'clsx';
    import Limiter from './Limiter.svelte';
    import Transition from './Transition.svelte';

    // Types
    import type { Padding } from '$lib/types/Components/SharedTypes';
    import type { TransitionEffect } from '$lib/types/Theme';

    export let top: Padding = 'medium';
    export let right: Padding = 'medium';
    export let bottom: Padding = 'medium';
    export let left: Padding = 'medium';
    export let backgroundColor = 'transparent';
    export let backgroundImage = '';
    export let className = '';
    export let rounded = false;
    export let fullHeight = false;

    // Transition
    export let transitionDelay = 0;
    export let transitionEffect: TransitionEffect = 'default';

    // Limiter
    export let narrow = false;
    export let medium = false;
    export let wide = false;
    export let desktop = false;

    let paddingClasses: string;

    $: paddingClasses = clsx(className, {
        'pt-2': top === 'small',
        'pt-4': top === 'medium',
        'pt-6': top === 'large',
        'pt-8': top === 'xLarge',
        'pl-2': left === 'small',
        'pl-4': left === 'medium',
        'pl-6': left === 'large',
        'pl-8': left === 'xLarge',
        'pr-2': right === 'small',
        'pr-4': right === 'medium',
        'pr-6': right === 'large',
        'pr-8': right === 'xLarge',
        'pb-2': bottom === 'small',
        'pb-4': bottom === 'medium',
        'pb-6': bottom === 'large',
        'pb-8': bottom === 'xLarge',
    });
</script>

<div
    class={clsx('border-box w-full', paddingClasses, {
        'rounded-lg sm:rounded-xl md:rounded-2xl': rounded,
        'h-full': fullHeight,
    })}
    style:background="{backgroundImage ? `url('${backgroundImage}')` : backgroundColor} no-repeat center
    center / cover"
>
    <Limiter {narrow} {medium} {wide} {fullHeight} {desktop}>
        <Transition delay={transitionDelay} effect={transitionEffect} {fullHeight}>
            <slot />
        </Transition>
    </Limiter>
</div>
